export default {
  beforeMount(el, binding) {
    // 定义事件处理函数
    el.__vueClickOutsideHandler__ = (event) => {
      // 检查点击是否发生在元素外部
      if (!el.contains(event.target) && el !== event.target) {
        // 调用绑定的方法
        binding.value(event)
      }
    }

    // 同时监听鼠标点击和触摸事件
    document.addEventListener('click', el.__vueClickOutsideHandler__)
    document.addEventListener('touchstart', el.__vueClickOutsideHandler__)
  },
  unmounted(el) {
    // 组件卸载时移除监听
    document.removeEventListener('click', el.__vueClickOutsideHandler__)
    document.removeEventListener('touchstart', el.__vueClickOutsideHandler__)
    delete el.__vueClickOutsideHandler__
  }
}
